import { asyncAction } from 'lib/actionCreators'

export const constants = asyncAction('auth/CONSTANTS')
